import { NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { PrimengModule } from 'src/app/primeng.module';
import { LightformsComponentsModule } from '@un-fao/lightforms-lib/lightforms-components';
import { LightformsCoreModule } from '@un-fao/lightforms-lib/lightforms-core';
import { LightformsServicesModule } from '@un-fao/lightforms-lib/lightforms-services';
import { LandedVolumeComponent } from './landed-volume/landed-volume.component';
import { FirmsMapComponent } from './firms-map/firms-map.component';
import { RelatedObservationsComponent } from './related-observations/related-observations.component';
import { IndicatorsComponent } from './indicators/indicators.component';
import { SpeciesListComponent } from './species-list/species-list.component';
import { LatestUpdatesComponent } from './latest-updates/latest-updates.component';

@NgModule({
  declarations: [
    LandedVolumeComponent,
    FirmsMapComponent,
    RelatedObservationsComponent,
    IndicatorsComponent,
    SpeciesListComponent,
    LatestUpdatesComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    PrimengModule,
    LightformsServicesModule,
    LightformsComponentsModule,
    LightformsCoreModule
  ],
  exports: [
    LandedVolumeComponent,
    FirmsMapComponent,
    RelatedObservationsComponent,
    IndicatorsComponent,
    SpeciesListComponent,
    LatestUpdatesComponent
  ]
})
export class CustomComponentsModule {
  static components: Record<string, Type<any>> = {
    'firms-map': FirmsMapComponent,
    'fishery-indicators': IndicatorsComponent,
    'landed-volume': LandedVolumeComponent,
    'latest-updates': LatestUpdatesComponent,
    'related-observations': RelatedObservationsComponent,
    'species-list': SpeciesListComponent
  };
}
